import React, { useContext } from 'react';
import { Form, Input } from 'antd';
import { AppContext } from 'App.context';
import useGuestDetailsFormHook from './GuestDetailsForm.hook';
import { ReactComponent as InfoIconBlack } from 'assets/images/info-icon-black.svg';

import './GuestDetails.css';

export default function GuestDetailsForm({ initialValues, onFormChange }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  useGuestDetailsFormHook({ form, values, onFormChange, initialValues });

  return (
    <div className="guest-details-container">
      <InfoIconBlack />
      <div className="guest-details-form">
        <span className="guest-details-form-title">
          {translate('createBooking.steps.guestDetails.holderData')}
        </span>
        <Form
          form={form}
          layout="vertical"
          className="guest-details-form"
          requiredMark={false}
          initialValues={initialValues}
        >
          <Form.Item
            label={translate('createBooking.steps.guestDetails.name')}
            name="name"
            rules={[{ required: true }]}
            required
            validateTrigger={[]}
          >
            <Input placeholder={translate('createBooking.steps.guestDetails.name')} />
          </Form.Item>
          <Form.Item
            label={translate('createBooking.steps.guestDetails.surname')}
            name="surname"
            rules={[{ required: true }]}
            required
            validateTrigger={[]}
          >
            <Input placeholder={translate('createBooking.steps.guestDetails.surname')} />
          </Form.Item>
          {/* Commented code for when we can make WhatsApp communications
          <Form.Item
            label={translate('createBooking.steps.guestDetails.phone')}
            name="phone"
            validateTrigger={[]}
          >
            <Input placeholder={translate('createBooking.steps.guestDetails.phone')} />
          </Form.Item> */}
          <Form.Item
            label={translate('createBooking.steps.guestDetails.email')}
            name="email"
            rules={[{ required: true }]}
            required
            validateTrigger={[]}
          >
            <Input placeholder={translate('createBooking.steps.guestDetails.email')} />
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}
